export const Features = {
  Accountability: 'Accountability',
  GPSTracking: 'GPS Tracking',
  BulkUploadButton: 'bulk-upload-button',
  Documentation: 'Documentation',
  AccountabilityDownloadButton: 'accountability-download-button',
  DVR: 'DVR',
} as const;

export type Feature = (typeof Features)[keyof typeof Features];

export const WEBAPP_RELEASE: Record<Feature, Date> = {
  [Features.Accountability]: new Date('2025-04-01'),
  [Features.GPSTracking]: new Date('2025-04-01'),
  [Features.BulkUploadButton]: new Date('2025-04-01'),
  [Features.Documentation]: new Date('2025-04-22'),
  [Features.AccountabilityDownloadButton]: new Date('2025-04-24'),
  [Features.DVR]: new Date('2025-05-02'),
};
